// All measurements in mm (jsPDF A4 landscape: 297mm x 210mm)
export const PDF_PAGE = {
  WIDTH: 297,
  HEIGHT: 210,
  MARGIN_X: 40,
  MARGIN_TOP: 20,
  MARGIN_BOTTOM: 4,
};

export const PDF_COLORS = {
  PURPLE_DARKEST: [45, 35, 71], // #2D2347 — header bg
  PURPLE_STANDARD: [122, 80, 209], // #7A50D1 — label text
  PURPLE_LIGHT: [158, 106, 255], // #9E6AFF — pill, accents
  PURPLE_LIGHTER: [211, 189, 255], // #D3BDFF — dividers
  TEAL: [56, 219, 224], // #38DBE0
  TEAL_DARKER: [46, 145, 153], // #2E9199
  ORANGE: [255, 123, 34], // #FF7B22
  PINK: [247, 152, 222], // #F798DE
  ST_BLACK: [43, 38, 53], // #2B2635 — body text
  WHITE: [255, 255, 255],
  DIVIDER: [228, 217, 255], // #E4D9FF — card borders
  CARD_BG: [248, 245, 255], // #F8F5FF — default card
  CHART_BG: [250, 250, 255], // #FAFAFF — chart card bg
  FOOTER_TEXT: [184, 160, 232], // #B8A0E8
};

// KPI card accent color rotation (top border + tint)
export const KPI_CARD_STYLES = [
  { accent: PDF_COLORS.PURPLE_LIGHT, bg: PDF_COLORS.CARD_BG, labelColor: PDF_COLORS.PURPLE_STANDARD },
  { accent: PDF_COLORS.TEAL, bg: [240, 253, 254], labelColor: PDF_COLORS.TEAL_DARKER },
  { accent: PDF_COLORS.ORANGE, bg: [255, 246, 241], labelColor: [183, 84, 17] },
  { accent: PDF_COLORS.PINK, bg: [255, 243, 252], labelColor: [192, 96, 161] },
];

export const PDF_FONTS = {
  FAMILY: 'helvetica',
};

export const PDF_HEADER = {
  HEIGHT: 16,
  ACCENT_HEIGHT: 1,
  PILL_RADIUS: 3,
  LOGO_ICON_SIZE: 7,
};

export const PDF_FOOTER = {
  HEIGHT: 10,
};
